import { Component, inject } from '@angular/core';
import { StatusOptions, Ignorering } from '../models/ignore';
import { TableColumn, TableConfig } from '../../shared/components/app-table/app-table-models';
import { IgnoreradeService } from './ignorerade.service';
import { ButtonSetItem } from '../../shared/components/app-button-set/app-button-set-models';
import { NameType } from '../../shared/models/models';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IgnoreradeEditDialogComponent } from './ignorerade-edit-dialog/ignorerade-edit-dialog.component';
import { Role } from '../anvandare/anvandare.models';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';

@Component({
    selector: 'lib-ignorerade',
    templateUrl: './ignorerade.component.html',
    styleUrls: ['./ignorerade.component.scss'],
    standalone: false
})
export class IgnoreradeComponent {
  private authorizationService = inject(AuthorizationService);
  private ignoreService = inject(IgnoreradeService);
  private dialogService = inject(DialogService);
  tableConfig: TableConfig = {};
  ref: DynamicDialogRef | null = null;
  selectedNameType = NameType.Smittamne;

  ignoreTypesButtonSet: ButtonSetItem[] = [
    { text: 'Smittämne', value: NameType.Smittamne, active: true },
    { text: 'Analys', value: NameType.Analys },
    { text: 'Provmaterial', value: NameType.Provmaterial },
    { text: 'Antibiotika', value: NameType.Antibiotika },
  ];

  ngOnInit(): void {
    this.getIgnoreringar(this.selectedNameType);
    this.initColumns();
  }

  private initColumns() {
    this.tableConfig.columns = [
      {
        field: 'name',
        header: 'Namn',
        sortByField: 'name',
        columnFilter: 'text',
      },
      this.getStatusColumn(),
      {
        field: 'labb_kod',
        header: 'Tillhör laboratorium',
        sortByField: 'labb_kod',
        columnFilter: 'multi-select',
      },
      { field: 'modifiedBy', header: 'Modifierad av', sortByField: 'modifiedBy' },
      {
        field: 'startDate',
        header: 'Skapad datum',
        type: 'date',
        sortByField: 'startDate',
      },
      {
        field: 'comments',
        header: 'Kommentar',
        sortByField: 'comments',
        type: 'icon',
        icon: 'fas fa-message',
        commentsAsTitle: true,
      },
    ];
  }

  onSelect(item: ButtonSetItem) {
    this.selectedNameType = item.value;
    this.getIgnoreringar(item.value);
  }

  onEdit(ignorering: Ignorering) {
    const dialogRef = this.dialogService.open(IgnoreradeEditDialogComponent, {
      header: 'Ändra ignorerad',
      width: '',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false,
      data: {
        ignorering: { ...ignorering },
        nameType: this.selectedNameType,
      },
    });

    if (!dialogRef) {
      return;
    }

    this.ref = dialogRef;
    dialogRef.onClose.subscribe((modifiedIgnorering: Ignorering) => {
      if (modifiedIgnorering) {
        this.updateIgnorering(modifiedIgnorering);
      }
    });
  }

  async getIgnoreringar(type: NameType) {
    this.tableConfig.rows = [];
    this.tableConfig.rows = await this.ignoreService.getIgnoreList(type);
  }

  async updateIgnorering(ignorering: Ignorering) {
    await this.ignoreService.putIgnorering(this.selectedNameType, ignorering);
    this.getIgnoreringar(this.selectedNameType);
  }

  private getStatusColumn(): TableColumn {
    return this.authorizationService.hasRole([Role.SuperanvandareIntern])
      ? {
          field: 'status',
          header: 'Status',
          sortByField: 'status',
          type: 'dropdown',
          dropdownOptions: [
            { value: 'AKTIV', label: 'Aktiv' },
            { value: 'INAKTIV', label: 'Inaktiv' },
          ],
          filterOptions: [
            { name: 'AKTIV', label: 'Aktiv' },
            { name: 'INAKTIV', label: 'Inaktiv' },
          ],
          click: (event: any) => this.updateIgnorering(event),
          columnFilter: 'multi-select',
        }
      : {
          field: 'status',
          header: 'Status',
          sortByField: 'status',
          columnFilter: 'multi-select',
          filterOptions: [
            { name: 'AKTIV', label: 'Aktiv' },
            { name: 'INAKTIV', label: 'Inaktiv' },
          ],
        };
  }
}
